















import Vue, { VueConstructor } from 'vue';

type ComponentTypes = VueConstructor<Vue>;
const VueComponent = Vue as ComponentTypes;

export default VueComponent.extend({
  props: {
    width: {
      type: Number,
      default: 30,
    },
  },
});
